'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from './Select';

class PriceGroup extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      priceMin: props.priceMin,
      priceMax: props.priceMax,
      typingMin: false,
      typingMax: false
    };

    this.timerMin = null;
    this.timerMax = null;

    this.setMinPrice = this.setMinPrice.bind(this);
    this.setMaxPrice = this.setMaxPrice.bind(this);
    this.handlerFocusInput = this.handlerFocusInput.bind(this);
  }

  static getDerivedStateFromProps (props, state) {
    const s = {};

    if (!state.typingMin) {
      s.priceMin = props.priceMin;
    }

    if (!state.typingMax) {
      s.priceMax = props.priceMax;
    }

    return s;
  }

  parseValue (number) {
    return isNaN(parseInt(number)) ? null : parseInt(number);
  }

  setMinPrice (e) {
    const priceMin = e.target.value;
    if (priceMin.length > 10) {
      return;
    }

    this.setState({priceMin, typingMin: true});

    clearTimeout(this.timerMin);
    this.timerMin = setTimeout(() => {
      this.setState({typingMin: false}, this.props.onUpdate({ priceMin: this.parseValue(priceMin) }));
    }, 800);
  }

  setMaxPrice (e) {
    const priceMax = e.target.value;
    if (priceMax.length > 10) {
      return;
    }

    this.setState({priceMax, typingMax: true});

    clearTimeout(this.timerMax);
    this.timerMax = setTimeout(() => {
      this.setState({typingMax: false}, () => this.props.onUpdate({ priceMax: this.parseValue(priceMax) }));
    }, 800);
  }

  handlerFocusInput (e) {
    e.target.select();
  }

  componentWillUnmount () {
    clearTimeout(this.timerMin);
    clearTimeout(this.timerMax);
  }

  render () {
    return (
      <div className='price-group-control-box'>
        <div className='flex'>
          <div className='price-group-control__input'>
            <input
              onFocus={this.handlerFocusInput}
              type='text'
              placeholder='Цена от'
              value={this.state.priceMin || ''}
              onChange={this.setMinPrice} />
          </div>
          <div className={'price-group-control__input' + (this.props.items ? ' no-border' : '')}>
            <input
              onFocus={this.handlerFocusInput}
              type='text'
              placeholder='Цена до'
              value={this.state.priceMax || ''}
              onChange={this.setMaxPrice} />
          </div>
          {
            this.props.items &&
            <Select
              items={this.props.items}
              name='priceUnitId'
              value={this.props.priceUnitId || 1}
              onUpdate={(_, value) => this.props.onUpdate({priceUnitId: value > 1 ? value : null})}
            />
          }
        </div>
      </div>
    );
  }
}

const itemType = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
});

PriceGroup.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  priceUnitId: PropTypes.number,

  items: PropTypes.arrayOf(itemType),
  onUpdate: PropTypes.func.isRequired                     // callback({name: value, ..., nameN: valueN})
};
PriceGroup.defaultProps = {
  priceMin: null,
  priceMax: null,
  priceUnitId: null,

  items: null
};

export default PriceGroup;



// WEBPACK FOOTER //
// ./src/ui/Controls/PriceGroup.jsx